import { useSetRecoilState } from "recoil";
import { taskSubmissionSearchAtom } from "../miscellaneous/taskSubmissionSearchAtom";

export const useSetTaskSubmissionSearch = () => {
  return useSetRecoilState(taskSubmissionSearchAtom);
};
